import {BATCH_ACTIONS} from '~/frontend/src/constants';


export type BatchActionsAction = {
    type : typeof BATCH_ACTIONS;
    actions : any
}

/**
 * @memberOf! Actions
 *
 * @param {any} actions
 * @return {BatchActionsAction}
 */
export default function batchActions( ...actions : any ) : BatchActionsAction {
    return {
        type   : BATCH_ACTIONS,
        actions: actions
    };
}

export type BatchActions = typeof batchActions;
